import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface SendOtpRequest {
    type: 'MOBILE' | 'EMAIL'
    value: string
    countryCode?: string
    action: 'SIGNIN' | 'SIGNUP' | 'SIGNUP_MERGE' | 'UPDATE_MOBILE'
}

export interface SendOtpResponse {
    commId: string
    status: 'SUCCESS' | 'ACCEPTED'
    action: 'SIGNIN' | 'SIGNUP' | 'SIGNUP_MERGE' | 'UPDATE_MOBILE'
    error?: string
    message?: string
}

export interface VerifyOtpRequest {
    type: 'MOBILE' | 'EMAIL'
    value: string
    countryCode?: string
    action: 'SIGNIN' | 'SIGNUP' | 'SIGNUP_MERGE' | 'UPDATE_MOBILE'
    otp: string
}

export interface VerifyOtpResponse {
    action: 'SIGNIN' | 'SIGNUP' | 'SIGNUP_MERGE' | 'UPDATE_MOBILE'
    error?: string
    message?: string
    success?: boolean
}

export const otpAuthApi = createApi({
    reducerPath: 'otpAuthApi',
    baseQuery: fetchBaseQuery({
        credentials: 'include',
        prepareHeaders: headers => {
            headers.set('accept', '*/*')
            // Use window.location.origin on client-side, fallback to NEXTAUTH_URL for SSR
            // The false case occurs during server-side rendering when window is undefined
            const caller =
                typeof window !== 'undefined'
                    ? window.location.origin
                    : process.env.NEXTAUTH_URL || 'https://me.flyin.com'
            headers.set('caller', caller)
            headers.set('content-type', 'application/json')
            headers.set('ab-otp', 'b')
            return headers
        }
    }),
    endpoints: builder => ({
        sendOtp: builder.mutation<SendOtpResponse, SendOtpRequest>({
            query: body => ({
                url: '/accounts/external-api/otp',
                method: 'POST',
                body
            })
        }),
        verifyOtp: builder.mutation<VerifyOtpResponse, VerifyOtpRequest>({
            query: body => ({
                url: '/accounts/external-api/otp/verify-action',
                method: 'POST',
                body
            })
        }),

        // Convenience endpoints specifically for EMAIL OTP flows
        sendEmailOtp: builder.mutation<SendOtpResponse, { value: string; action: 'SIGNUP_MERGE' | 'SIGNIN' }>({
            query: ({ value, action }) => ({
                url: '/accounts/external-api/otp',
                method: 'POST',
                body: {
                    type: 'EMAIL',
                    value,
                    action
                }
            })
        }),
        verifyEmailOtp: builder.mutation<
            VerifyOtpResponse,
            { value: string; otp: string; action: 'SIGNUP_MERGE' | 'SIGNIN' }
        >({
            query: ({ value, otp, action }) => ({
                url: '/accounts/external-api/otp/verify-action',
                method: 'POST',
                body: {
                    type: 'EMAIL',
                    value,
                    otp,
                    action
                }
            })
        })
    })
})

export const { useSendOtpMutation, useVerifyOtpMutation, useSendEmailOtpMutation, useVerifyEmailOtpMutation } =
    otpAuthApi
